import type { AnalyticsEventData } from '@cbhq/client-analytics';
import { ActionType, ComponentType } from '@cbhq/client-analytics';

export const ONRAMP_FLOW = 'onramp_flow';

type NamedAnalyticsEventData = AnalyticsEventData & {
  name: string;
};

const ONRAMP_FLOW_EVENT = {
  action: ActionType.view,
  componentType: ComponentType.page,
};

const ONRAMP_FLOW_USER_CLICK_ACTION = {
  action: ActionType.click,
};

const ONRAMP_FLOW_BUTTON = {
  componentType: ComponentType.button,
};

export const ONRAMP_INPUT_VIEWED: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_EVENT,
  loggingId: 'bd9b4c33-b372-4174-b424-581c7fc84259',
  name: 'ONRAMP_INPUT_VIEWED',
};

export const ONRAMP_INPUT_REDIRECTED_TO_AUTHED: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_USER_CLICK_ACTION,
  ...ONRAMP_FLOW_BUTTON,
  loggingId: 'e26fba6f-0746-4f44-8788-b502e857fbc9',
  name: 'ONRAMP_INPUT_REDIRECTED_TO_AUTHED',
  isGuestCheckoutEligible: false,
};

export const ONRAMP_INPUT_BACK: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_USER_CLICK_ACTION,
  ...ONRAMP_FLOW_BUTTON,
  loggingId: '41500387-99a2-4095-897f-23b4e15af9ac',
  name: 'ONRAMP_INPUT_BACK',
};

export const ONRAMP_INPUT_CONTINUE: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_USER_CLICK_ACTION,
  ...ONRAMP_FLOW_BUTTON,
  loggingId: 'c5a52aff-3b88-4000-8ac4-e80b7c43561b',
  name: 'ONRAMP_INPUT_CONTINUE',
};

export const ONRAMP_CHANGE_NETWORK_VIEWED: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_EVENT,
  loggingId: 'b7b1cfce-33c7-4191-9967-08217de643d6',
  name: 'ONRAMP_CHANGE_NETWORK_VIEWED',
};

export const ONRAMP_FLOW_NETWORK_CHANGED: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_USER_CLICK_ACTION,
  ...ONRAMP_FLOW_BUTTON,
  loggingId: '15b3d78c-994f-422a-b325-279a7b2b6fc0',
  name: 'ONRAMP_FLOW_NETWORK_CHANGED',
};

export const ONRAMP_FLOW_NETWORK_BACK: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_USER_CLICK_ACTION,
  ...ONRAMP_FLOW_BUTTON,
  loggingId: '7c701899-916c-4c23-8005-ff92a895c286',
  name: 'ONRAMP_FLOW_NETWORK_BACK',
};

export const ONRAMP_CHANGE_ASSET_VIEWED: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_EVENT,
  loggingId: '99e3ef29-80c7-4372-a388-d19fe111e8ec',
  name: 'ONRAMP_CHANGE_ASSET_VIEWED',
};

export const ONRAMP_CHANGE_ASSET_BACK: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_USER_CLICK_ACTION,
  ...ONRAMP_FLOW_BUTTON,
  loggingId: '277fbbef-7284-4482-a2e0-83719e5d8a74',
  name: 'ONRAMP_CHANGE_ASSET_BACK',
};

export const ONRAMP_FLOW_ASSET_SELECTED: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_USER_CLICK_ACTION,
  ...ONRAMP_FLOW_BUTTON,
  loggingId: '03d530b6-b562-4758-8c2c-e9d72a1250d8',
  name: 'ONRAMP_FLOW_ASSET_SELECTED',
};

export const ONRAMP_APPLE_PAY_SETUP_VIEWED: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_EVENT,
  loggingId: 'b688bd5f-0a1f-4895-b00e-df2b1d59a8bf',
  name: 'ONRAMP_APPLE_PAY_SETUP_VIEWED',
};

export const ONRAMP_APPLE_PAY_SETUP_SUCCESS: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_EVENT,
  loggingId: '71ed4512-f2db-4807-b38f-b3e6402bc95f',
  name: 'ONRAMP_APPLE_PAY_SETUP_SUCCESS',
};

export const ONRAMP_APPLE_PAY_SETUP_FAIL: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_EVENT,
  loggingId: 'aadfc4e5-9643-40a8-8222-ea4584321357',
  name: 'ONRAMP_APPLE_PAY_SETUP_FAIL',
};

export const ONRAMP_APPLE_PAY_SETUP_ERROR: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_EVENT,
  loggingId: '229ed30a-de11-4e73-819b-7ae0ce5cb7e9',
  name: 'ONRAMP_APPLE_PAY_SETUP_ERROR',
};

export const ONRAMP_APPLE_PAY_SETUP_BACK: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_EVENT,
  loggingId: '5adb3700-2d56-492c-bbb0-8700a1a1141c',
  name: 'ONRAMP_APPLE_PAY_SETUP_BACK',
};

export const ONRAMP_APPLE_PAY_SETUP_EXIT: NamedAnalyticsEventData = {
  ...ONRAMP_FLOW_EVENT,
  loggingId: 'b4506a85-3597-4b9b-8e8a-19c9184852d4',
  name: 'ONRAMP_APPLE_PAY_SETUP_EXIT',
};
